import { api, get } from './client';
import type { ApiSuccess } from '@todo/shared';

/** One prior turn, replayed so the assistant keeps context. */
export interface ChatTurn {
  role: 'user' | 'assistant';
  content: string;
}

export interface ChatHelpModule {
  module: string;
  description: string;
  examples: string[];
}

export interface ChatHelp {
  enabled: boolean;
  modules: ChatHelpModule[];
}

export const chatApi = {
  /** The agent can make several model round trips - give it longer than the
   *  client's default 20s. `changed` means a write tool ran - the widget
   *  broadcasts it so open pages refetch. */
  async send(
    message: string,
    history: ChatTurn[],
  ): Promise<{ reply: string; changed: boolean }> {
    const res = await api.post<ApiSuccess<{ reply: string; changed?: boolean }>>(
      '/chat',
      { message, history },
      { timeout: 90_000 },
    );
    return { reply: res.data.data.reply, changed: res.data.data.changed === true };
  },

  help(): Promise<ChatHelp> {
    return get<ChatHelp>('/chat/help');
  },
};
